import { configureStore } from "@reduxjs/toolkit";
import jobReducer from "../features/jobs/jobSlice";

// configure store , redux toolkit function 
export const store = configureStore({
  reducer: {
    job: jobReducer,  // ne degisicekse o burada belirtiyoruz
  },
});

export default store; // store u disariya aktariyoruz